import router from '@/router'
import { mapState } from 'vuex'
export default {
    data() {
        return {}
    },
    computed: {
        ...mapState([]),
    },
    created() {},
    mounted() {},
    destroyed() {},
    methods: {},
}
